import * as React from 'react';

import {Button} from '@mui/material'

import DashboardContainer from '../../components/admin/DashboardContainer'
import CompaniesList from '../../components/admin/company/CompaniesList'

import { useHistory, Link } from 'react-router-dom';

import DailyCode from '../../components/admin/DailyCode';

export default function Companies() {
  const history = useHistory();

  const handleCreateCompany = () => {
    history.push('/admin/companies/create');
  };

  return (
    <DashboardContainer title={'Empresas'}>

      <DailyCode/>

      <CompaniesList />

      <Button variant="contained" onClick={handleCreateCompany} style={{ marginTop: '1rem' }}>
        Registrar empresa
      </Button>

    </DashboardContainer>
  );
}